module.exports = __webpack_public_path__ + "static/img/partner_V.8d799ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_V.png
// module id = A29R
// module chunks = 9